import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { TrendUp } from "@phosphor-icons/react";

const fmt = (iso) => new Date(iso).toLocaleString([], { dateStyle: "medium", timeStyle: "short" });

const STATUS = {
  confirmed: "bg-[#16A34A]",
  built: "bg-[#EAB308]",
  cancelled: "bg-zinc-400",
};

export default function ProductionLog() {
  const [runs, setRuns] = useState(null);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    api.get("/production").then((r) => setRuns(r.data || [])).catch(() => setRuns([]));
  }, []);

  return (
    <>
      <PageHeader title="Production Log" subtitle={runs ? `${runs.length} production run${runs.length === 1 ? "" : "s"}` : "Loading…"} />
      <div className="p-4 sm:p-8">
        <div className="bg-white border border-zinc-300">
          <div className="flex items-center gap-2 px-6 py-4 border-b border-zinc-300 bg-zinc-50">
            <TrendUp size={18} weight="bold" className="text-zinc-800" />
            <h3 className="font-heading font-bold uppercase tracking-tight text-sm">Complete Production History</h3>
          </div>
          {runs === null ? (
            <p className="p-6 text-sm text-zinc-400">Loading…</p>
          ) : runs.length === 0 ? (
            <p className="p-6 text-sm text-zinc-400" data-testid="production-empty">No production runs recorded yet.</p>
          ) : (
            <div className="divide-y divide-zinc-200" data-testid="production-full-list">
              {runs.map((r) => (
                <div key={r.id} className="flex items-center justify-between px-6 py-3" data-testid={`production-full-${r.id}`}>
                  <div className="flex items-center gap-3">
                    <span className="font-mono text-sm font-bold bg-zinc-900 text-white px-2 py-1">{r.model}</span>
                    <div>
                      {r.order_no && <span className="font-mono text-xs font-bold text-primary mr-2">{r.order_no}</span>}
                      <span className="text-sm text-zinc-900">{r.made ?? r.quantity} / {r.quantity} made</span>
                      {r.bom_name && <span className="ml-2 text-[11px] font-bold uppercase tracking-wide bg-zinc-100 text-zinc-600 px-1.5 py-0.5">{r.bom_name}</span>}
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <span className={`inline-block px-2 py-0.5 text-[10px] font-bold uppercase text-white ${STATUS[r.status] || "bg-zinc-400"}`}>
                      {r.status || "built"}
                    </span>
                    <p className="text-[11px] text-zinc-400 min-w-[170px] text-right">{r.by_name} · {fmt(r.created_at)}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
